import { render } from "./ForgotPassword.vue?vue&type=template&id=6c849c6e"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"

import "./ForgotPassword.vue?vue&type=style&index=0&id=6c849c6e&lang=css"
script.render = render

export default script